import { DeviceInfo } from 'ngx-device-detector';

export class Device {
  info: DeviceInfo = null;
  mobile = false;
  tablet = false;
  desktop = false;
}
